<template>
    <!-- tab 按后端下发的导航树显示，没权限的不出现 -->
    <el-menu class="left-sidebar-menu" @select="handleSelect" :default-active="$route.path">
        <el-menu-item v-if="can('application_list')" index="/abroad/app/list">
            <i class="el-icon-menu app-store"></i>
            <span slot="title">{{ $t("title.appList")}}</span>
        </el-menu-item>
        <el-menu-item v-if="can('ad_zone_list')" index="/abroad/ad/list">
            <i class="el-icon-document ad-icon"></i>
            <span slot="title">{{ $t("title.adsenseList")}}</span>
        </el-menu-item>
        <el-menu-item v-if="can('block_manage')" index="/abroad/block/list">
            <i class="el-icon-document el-icon-folder-delete"></i>
            <span slot="title">{{ $t("title.blockManage")}}</span>
        </el-menu-item>
  </el-menu>
</template>
<script>
    import perm from '@/utils/permission'
    export default {
        created() {
            perm.load().catch(() => {})
        },
        methods: {
           // 导航树还没加载时 hasMenu 全放，按主账号显示
           can(key) {
                return perm.hasMenu(key)
           },
           handleSelect(key, keyPath) {
                return this.$router.push(key)
           },
        }
    }
</script>

<style>
.el-menu-item .app-store.el-icon-menu:before{
    content:'';
    display: inline-block;
    width:20px;
    height: 20px;
    background:url(../../../../../assets/img/app-store-grey.png);
    background-size: 100%;
    background-position: center center;
    background-repeat: no-repeat;
    vertical-align: bottom;
}
.el-menu-item.is-active .app-store.el-icon-menu:before{
    content:'';
    display: inline-block;
    width:20px;
    height: 20px;
    background:url(../../../../../assets/img/app-store-blue.png);
    background-size: 100%;
    background-position: center center;
    background-repeat: no-repeat;
    vertical-align: bottom;
}
.el-menu-item .ad-icon.el-icon-document:before{
    content:'';
    display: inline-block;
    width:20px;
    height: 20px;
    background:url(../../../../../assets/img/ad-list-grey.png);
    background-size: 100%;
    background-position: center center;
    background-repeat: no-repeat;
    vertical-align: bottom;
}
.el-menu-item.is-active .ad-icon.el-icon-document:before{
    content:'';
    display: inline-block;
    width:20px;
    height: 20px;
    background:url(../../../../../assets/img/ad-list-blue.png);
    background-size: 100%;
    background-position: center center;
    background-repeat: no-repeat;
    vertical-align: bottom;
}

</style>
